import Request from '../request';

export interface ITargetSummaryProps {
    employeeId: string;
    period?: 'month' | 'year' | string;
    periodLabel?: string;
    month: string;
    date: string;
    basedOn?: string;
    targetAmount: number;
    monthlyTarget?: number;
    targetType: 'omset' | 'profit' | string;
    achievedAmount: number;
    remainingAmount: number;
    percentage: number;
    isTargetMet: boolean;
    ordersCount: number;
    contract?: {
        id: string;
        employeeType?: string;
        startDate?: string;
        endDate?: string | null;
    };
}


const EmployeeTargetSummaryService = {

    get: async (
        employeeId: string,
        date?: string,
        basedOn?: string,
        period?: 'month' | 'year' | string,
        contractId?: string
    ): Promise<ITargetSummaryProps> => {
        const params = new URLSearchParams();
        if (date) params.append('date', date);
        if (basedOn) params.append('basedOn', basedOn);
        if (period) params.append('period', period);
        if (contractId) params.append('contractId', contractId);

        const qs = params.toString();
        const url = `/api/employees/${employeeId}/target-summary${qs ? '?' + qs : ''}`;
        const response = await Request.get(url);
        return (response && response.percentage !== undefined) ? response : (response?.data || response);
    }
};

export default EmployeeTargetSummaryService;
